export const RESET_REQUEST_INCOGNITO_STATUS =
  'RESET_REQUEST_INCOGNITO_STATUS' as const
export const resetRequestIncognitoStatusAction = () => ({
  type: RESET_REQUEST_INCOGNITO_STATUS,
})
